import { createSelector } from '@reduxjs/toolkit';
import { configSelector } from './slices/config';
import { modulesSelector } from './slices/modules';
import { userSelector } from './slices/user';
import { planDataSelector } from './slices/plan';
export const contentDataSelector = createSelector([userSelector, configSelector, modulesSelector, planDataSelector], (user, config, modules, plan) => ({
    user,
    config,
    modules,
    plan,
}));
//# sourceMappingURL=selectors.js.map